import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  // IMPORTANT : on n'envoie PAS les cookies (`withCredentials: false`).
  // L'auth fonctionne via le header `Authorization: Bearer` géré ci-dessous
  // (token stocké en localStorage). Activer `withCredentials: true` casserait le CORS
  // car le proxy ingress renvoie `Access-Control-Allow-Origin: *`, ce qui est interdit
  // par la spec quand la requête inclut des credentials → le navigateur rejette la réponse
  // « instantanément » (e.response = undefined côté axios → fallback "Une erreur est
  // survenue" sur le 1er essai de login en production). Voir tickets liés au 08/02/2026.
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

export function setAuthHeader(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("plania_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("plania_token");
  }
}

// Bootstrap stored token
const stored = typeof window !== "undefined" ? localStorage.getItem("plania_token") : null;
if (stored) {
  api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
